import styled from '@emotion/styled'
import Form from 'antd/lib/form'

const badgeLineStyles = `
  font-size: 12px;
  font-weight: 500;

  display: flex;
  align-items: center;
  gap: 8px;
`

export const StatusTag = styled.div(
  ({ enabled }: { enabled: boolean }) => `
  color: ${enabled ? '#4EB21C' : '#E2232D'};
  ${badgeLineStyles}
`
)

export const StatusIcon = styled.div(
  ({ enabled }: { enabled: boolean }) => `
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${enabled ? '#4EB21C' : '#E2232D'};
`
)

export const HiddenTag = styled.div`
  color: #4a4a68;
  ${badgeLineStyles}
`

export const StatusColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`

export const FormActions = styled(Form.Item)`
  margin: 12px 0;
`
